var parent = require('../../es/array/is-array');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/array/is-array.js
// module id = 883
// module chunks = 168707334958949